import { doc, getDocFromServer } from 'firebase/firestore'
import firestore from '../../firestore'
import { PromotionalCodeRedemption } from '@leadgen/models/client'

class PromotionalCodeRedemptionService {
  fetchPromotionalCodeRedemption = async ({
    companyId,
    promotionalCodeId,
  }: {
    companyId: string
    promotionalCodeId: string
  }) => {
    const promotionalCodeRedemptionRef = doc(
      firestore.promotionalCodeRedemptions(companyId),
      promotionalCodeId,
    )
    const promotionalCodeRedemptionDoc = await getDocFromServer(promotionalCodeRedemptionRef)
    if (!promotionalCodeRedemptionDoc.exists()) {
      return null
    }
    return promotionalCodeRedemptionDoc.data() as PromotionalCodeRedemption
  }
}

export default new PromotionalCodeRedemptionService()
